module.exports = __webpack_public_path__ + "img/html5-brands.ddb7960b.svg";